import type { CylanceConsole, ResponseError } from '@rtkwlf/eloc';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { shortCacheOptions } from '@platform/core/state';

import { useElocApi } from '../../use-eloc-api';

import { getCylanceConsoleQueryKey } from './cylance-console';

// TODO: Remove this hook after migration to new portal
export const useCylanceConsole = (
  options?: Omit<
    UseQueryOptions<CylanceConsole[], ResponseError>,
    'queryFn' | 'queryKey'
  >,
) => {
  const elocApi = useElocApi();

  return useQuery({
    queryKey: getCylanceConsoleQueryKey(),
    queryFn: () => elocApi.getCylanceConsole(),
    ...shortCacheOptions,
    ...options,
  });
};
